import { Component, Prop, h } from '@stencil/core';
import { LineItem } from '@artask/tambr-models/models/orders.model';


@Component({
  tag: 'tambr-checkout-order-price',
  styleUrl: 'tambr-checkout-order-price.css',
  shadow: true,
})
export class TambrCheckoutOrderPrice {

  @Prop() priceBreakdown: LineItem[];

  render() {
    if ( !this.priceBreakdown?.length ) return;
    return (
      <div class='price-breakdown'>
        <ul>{ this.priceBreakdown.map( lineItem => this.renderPriceLine( lineItem ) ) }</ul>
      </div>  
    );
  }

  renderPriceLine( lineItem: LineItem ) {
    return (
      <li class={ 'price-line ' + lineItem.type + ' level' + lineItem.level }>
        <span class='price-line-label'>{ lineItem.label }</span>
        <span class='price-line-value'>
          { ['discount', 'credits', 'credit'].includes( lineItem.type ) ? '– ' : '' }${ (lineItem.amount/100).toFixed(2) }
        </span>
      </li>
    );
  }

}